import * as Types from './CustomerActionTypes';
import * as CustomerServices from '../../../services/CustomerServices';

export const craeteCustomerAction = (customer) => {
    return { type: Types.CREATE_CUSTOMER, payload: customer };
};

export const getCustomerAction = (customer, customerId) => {
    return { type: Types.READ_CUSTOMER, payload: { customer, customerId } };
};

export const updateCustomerAction = (customer, customerId) => {
    return { type: Types.UPDATE_CUSTOMER, payload: { customer, customerId } };
};
export const deleteCustomerAction = (customerId) => {
    return { type: Types.DELETE_CUSTOMER, payload: customerId };
};

export const getTrackingById = (trackings, customerId,trackingId) => {
    return { type: Types.GET_TRACKING_BY_ID, payload: { trackings,customerId,trackingId } };
};

export const getAllTrackingsAction = (tracking) => {
    return { type: Types.GET_ALL_TRACKINGS, payload: { tracking } };
};

export const clearCustomerStateAction = () => {
    return { type: Types.CLEAR_STATE, payload: [] };
};

export const getCustomer = (customerId = 0) => {
    console.log('readCustomer called with id', customerId);
    return async (dispatch) => {
        if (customerId > 0) 
            return CustomerServices.get(customerId)
                .then((customer) => {
                    dispatch(getCustomerAction(customer, customerId));
                })
                .catch((error) => console.log('Error:', error));
        else 
            return CustomerServices.getAll()
                .then((customer) => {
                    dispatch(getCustomerAction(customer, customerId));
                })
                .catch((error) => console.log('Error:', error));
    };
};

export const createCustomer = (customer) => {
    return (dispatch) => {
        CustomerServices.register(customer)
            .then((customer) => {
                dispatch(craeteCustomerAction(customer));
            })
            .catch((error) => console.log('Error:', error));
    };
};

export const updateCustomer = (customer,customerId) => {
    console.log('inside UpdateCustomer', customerId);
    return async (dispatch) => {
        return CustomerServices.update(customer,customerId)
            .then(() => {
                dispatch(updateCustomerAction(customer,customerId));
            })
            .catch((error) => console.log('Error:', error));
        
    };
};

export const deleteCustomer = (customerId) => {
    console.log('inside deleteCustomer', customerId);
    return async (dispatch) => {
        return CustomerServices.remove(customerId)
            .then(() => {
                dispatch(deleteCustomerAction(customerId));
            })
            .catch((error) => console.log('Error:', error));
    };
};


export const getAllTrackings = (customerId = 0) => {
    console.log('get Trackings called with customer id', customerId);
    return async (dispatch) => {
        try {
            const tracking = await CustomerServices.getTrackings(customerId);
            dispatch(getAllTrackingsAction(tracking));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};